// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    ChevronsUpDown,
    Church,
    Cigarette,
    CigaretteOff,
    Circle,
    CircleAlert,
    CircleArrowDown,
    CircleArrowLeft,
    CircleArrowOutDownLeft,
    CircleArrowOutDownRight,
    CircleArrowOutUpLeft,
    CircleArrowOutUpRight,
    CircleArrowRight,
    CircleArrowUp,
    CircleCheck,
    CircleCheckBig,
    CircleChevronDown,
    CircleChevronLeft,
    CircleChevronRight,
    CircleChevronUp,
    CircleDashed,
    CircleDivide,
    CircleDollarSign,
    CircleDot,
    CircleDotDashed,
    CircleEllipsis,
    CircleEqual,
    CircleEuro,
    CircleFadingArrowUp,
    CircleFadingPlus,
    CircleGauge,
    CircleMinus,
    CircleOff,
    CircleParking,
    CircleParkingOff,
    CirclePause,
    CirclePercent,
    CirclePile,
    CirclePlay,
    CirclePlus,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "chevrons-up-down" through "circle-plus", inclusive. */
const shard: Record<string, LucideIcon> = {
    "chevrons-up-down": ChevronsUpDown,
    church: Church,
    cigarette: Cigarette,
    "cigarette-off": CigaretteOff,
    circle: Circle,
    "circle-alert": CircleAlert,
    "circle-arrow-down": CircleArrowDown,
    "circle-arrow-left": CircleArrowLeft,
    "circle-arrow-out-down-left": CircleArrowOutDownLeft,
    "circle-arrow-out-down-right": CircleArrowOutDownRight,
    "circle-arrow-out-up-left": CircleArrowOutUpLeft,
    "circle-arrow-out-up-right": CircleArrowOutUpRight,
    "circle-arrow-right": CircleArrowRight,
    "circle-arrow-up": CircleArrowUp,
    "circle-check": CircleCheck,
    "circle-check-big": CircleCheckBig,
    "circle-chevron-down": CircleChevronDown,
    "circle-chevron-left": CircleChevronLeft,
    "circle-chevron-right": CircleChevronRight,
    "circle-chevron-up": CircleChevronUp,
    "circle-dashed": CircleDashed,
    "circle-divide": CircleDivide,
    "circle-dollar-sign": CircleDollarSign,
    "circle-dot": CircleDot,
    "circle-dot-dashed": CircleDotDashed,
    "circle-ellipsis": CircleEllipsis,
    "circle-equal": CircleEqual,
    "circle-euro": CircleEuro,
    "circle-fading-arrow-up": CircleFadingArrowUp,
    "circle-fading-plus": CircleFadingPlus,
    "circle-gauge": CircleGauge,
    "circle-minus": CircleMinus,
    "circle-off": CircleOff,
    "circle-parking": CircleParking,
    "circle-parking-off": CircleParkingOff,
    "circle-pause": CirclePause,
    "circle-percent": CirclePercent,
    "circle-pile": CirclePile,
    "circle-play": CirclePlay,
    "circle-plus": CirclePlus,
};

export default shard;
